import { render, staticRenderFns } from "./DebugCodeBlock.vue?vue&type=template&id=4a627579&scoped=true&lang=pug&"
import script from "./DebugCodeBlock.vue?vue&type=script&lang=js&"
export * from "./DebugCodeBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a627579",
  null
  
)

export default component.exports